import TabStackLayout from '@/views/layouts/TabStackLayout'

export default function NotificationsLayout() {
  return <TabStackLayout title="通知" />
}
